const getDefaultState = () => {
  return {
    menu: false,
  };
};

export default getDefaultState;
